import { RequestQueryOptions } from '@approvalmax/data';
import { domain } from 'modules/data';
import { useMemo } from 'react';
import { GetPaymentDetailsForBatchPayment, useGetPaymentDetailsForBatchPayment } from 'shared/data/webApp/v2';

export const useLineItemsEnrichedByPaymentDetails = (
    companyId: string,
    requestId: string,
    items: domain.AmaxPayPaymentItem[],
    getPaymentDetailsQueryOptions?: RequestQueryOptions<GetPaymentDetailsForBatchPayment>
) => {
    const { data: paymentDetailsForBatchPayment, isLoading: isLoadingPaymentDetailsForBatchPayment } =
        useGetPaymentDetailsForBatchPayment({ path: { companyId, requestId } }, getPaymentDetailsQueryOptions);

    const paymentDetailsForBatchPaymentMap = useMemo(
        () => new Map((paymentDetailsForBatchPayment?.items || []).map((item) => [item.versionId, item])),
        [paymentDetailsForBatchPayment?.items]
    );

    const enrichedLineItems = useMemo(
        () =>
            items.map((item) => {
                const paymentDetails = paymentDetailsForBatchPaymentMap.get(item.paymentDetails?.versionId || '');

                return {
                    ...item,
                    paymentDetails: paymentDetails || item.paymentDetails,
                };
            }),
        [items, paymentDetailsForBatchPaymentMap]
    );

    return {
        lineItems: enrichedLineItems,
        isLoadingPaymentDetailsForBatchPayment,
        paymentDetailsForBatchPaymentMap,
    };
};
